import { FC } from 'react'

import { SegmentedControl } from 'cng-common/components/segmentedControl'
import { Translation } from 'cng-common/features/translations'
import { TRevenueAndSobHierarchyOrder } from 'partner360/features/financialCockpit/lib'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../configs/translations'
import { CockpitSegmentedControlAccent } from '../cockpitSegmentedControlAccent'

const KEYS = FINANCIAL_COCKPIT_TRANSLATION_KEYS.revenueAndSob

interface ICockpitHierarchyOrderProps {
  selectedOrder: TRevenueAndSobHierarchyOrder
  onSelectOrder: (order: TRevenueAndSobHierarchyOrder) => void
}

/** Which axis a hierarchy table nests outermost — shown above the Revenue & SOB and Plan Quality
 *  tables whenever their Geo axis is enabled (manager cockpit mode). */
export const CockpitHierarchyOrder: FC<ICockpitHierarchyOrderProps> = ({
  selectedOrder,
  onSelectOrder,
}) => (
  <CockpitSegmentedControlAccent>
    <SegmentedControl
      useItemKeys
      selectedItem={selectedOrder}
      onItemSelect={onSelectOrder}
      size="small"
      variant="veneer"
    >
      <SegmentedControl.Item itemKey="productGeo">
        <Translation text={KEYS.columnOrderProductGeo} span />
      </SegmentedControl.Item>
      <SegmentedControl.Item itemKey="geoProduct">
        <Translation text={KEYS.columnOrderGeoProduct} span />
      </SegmentedControl.Item>
    </SegmentedControl>
  </CockpitSegmentedControlAccent>
)
